<template>
<div>
    <!-- modal -->
    <b-modal id="uploadServiceFeeFromExcelFormModal" centered size="xl" no-close-on-backdrop ref="uploadServiceFeeFromExcelFormModal" :title="$t('uploadServiceFeeFrom.title')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="saveTpmkExcel">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-4">
                    <label for="einvoice-transfer-records-year-input">{{ $t('einvoiceTransferRecords.year') }}</label>
                    <b-form-input id="einvoice-transfer-records-year-input" disabled v-model="year" size="sm"  type="number" maxlength="100"/>
                </b-col>

                <b-col class="col-lg-8">
                    <validation-provider #default="{ errors }" :name=" $t('uploadServiceFeeFrom.folder_name')" rules="required">
                        <label for="agent-annuity-folder-name-input">{{ $t('uploadServiceFeeFrom.folder_name') }}</label>
                        <b-input-group>
                            <b-form-input size="sm" id="folder-name-input" v-model="documentName" maxlength="50" :state="errors.length > 0 ? false:null" />
                            <b-input-group-append>
                                <b-button  size="sm" variant="outline-primary" onclick="document.getElementById('tpmkFileSelect').click()">{{ $t('others.select') }}
                                </b-button>
                                <b-form-file size="sm" style="display:none" id="tpmkFileSelect" accept="*.*" @change="uploadTmpkFee" :placeholder=" $t('uploadServiceFeeFrom.select_folder')" :drop-placeholder=" $t('uploadServiceFeeFrom.select_folder_info')" />
                            </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>

            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getServiceFeeList: {
            type: Function
        },
    },
    data() {
        return {        
            year: 0,  
            documentName: '',
            documentFile: '',
            documentType: '',    
        }
    },
    methods: {
        showInfo() {
            this.$refs['uploadServiceFeeFromExcelFormModal'].show()
            this.year = new Date().getFullYear();
        }, 
        async uploadTmpkFee(e) {
            var fileInfo = await this.$getFileInfo(e.target.files[0])
            this.documentName = fileInfo.name
            this.documentType = fileInfo.contentType
            this.documentFile = fileInfo.base64
        },
        async saveTpmkExcel() {
            this.$refs.simpleRules.validate().then(success => {
                const data = {
                    year: this.year,
                    base64: this.documentFile,
                    fileName: this.documentName,
                    documentType: this.documentType ,
                    employeeId: localStorage.getItem('EmployeeId')
                }

                const controller = {
                    name: 'serviceFee',
                    actionName: 'readServiceFeeFromTpmkExcel'
                }
                const payload = {
                    data: data,
                    controller: controller
                }

                if (success) {
                    let loader = this.$loading.show()
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('uploadServiceFeeFromExcelFormModal')
                            this.$SaveAlert()
                            this.getAnnuityList()                            
                            this.hiddenClientControl = false
                        } 
                        else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                        loader.hide()
                    })                   
                }
            })      
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
